
import { Strategy } from "@/types/strategy-types";
import { storeFollowedStrategy } from "@/utils/strategyUtils";
import { supabase } from "@/integrations/supabase/client";

export const useStrategyFollowHandler = () => {
  const followStrategy = async (strategy: Strategy, transformStrategy: (strategy?: Strategy) => any) => {
    const currentUser = await supabase.auth.getUser();
    const userId = currentUser.data.user?.id;

    if (!userId) {
      throw new Error("User not found");
    }

    console.log("Storing followed strategy after successful payment");
    const transformedStrategy = transformStrategy(strategy);
    
    if (transformedStrategy) {
      const followSuccess = await storeFollowedStrategy({
        strategy: transformedStrategy,
        userId,
        originalStrategyId: strategy.id
      });
      
      if (!followSuccess) {
        console.warn("Warning: Successfully paid but failed to store strategy follow");
      }
    }
  };

  return { followStrategy };
};
